export const financeAccessFieldToName = {
  patientPaymentAccess: 'Patient Payment Access',
  financeDetailsAccess: 'Finance Details Access',
  remittanceNotification: 'Remittance Notification',
  expensesAccess: 'Expenses Access'
};
